// extracted by mini-css-extract-plugin
export default {"mainRow":"UploadImage_mainRow__t8rk4","contentRow":"UploadImage_contentRow__jkA33","title":"UploadImage_title__mfOBn","desc":"UploadImage_desc__dbQDh","img":"UploadImage_img__H7-fK"};